<div class="d-flex flex-column gap-1">
  <div class="d-flex flex-row gap-2">
    <div class="card w-100 p-3 border-0 bg-light rounded-3 align-items-center mb-3">
      <div class="d-flex gap-2 align-items-center">
        @if (canWriteDeals()) {
          @for (signer of signers(); track signer.id) {
            <button
              type="button"
              class="btn btn-primary btn-h45"
              (click)="setSignatureForSigner(signer.id)"
              [disabled]="
                !isPdfLoaded() || signer.status === RecipientStatus.Complete || signer.status === RecipientStatus.Signed
              "
            >
              <i class="bi bi-person lh-1"></i>Sign for {{ displaySignerName(signer) }} ({{
                displaySignerType(signer)
              }})
            </button>
          }
          <button
            type="button"
            class="btn btn-secondary btn-h45"
            (click)="openSignaturePad()"
            [disabled]="!isPdfLoaded()"
          >
            <i class="bi bi-hand-index"></i>Take Signature via TrackPad
          </button>
        }
      </div>
    </div>
  </div>
  <div>
    <ngx-extended-pdf-viewer
      [src]="documentUrl()"
      (pdfLoadingStarts)="onPdfLoadingStarts()"
      (pdfLoaded)="onPdfLoaded()"
      (pdfLoadingFailed)="onPdfLoadingFailed($event)"
      [showPropertiesButton]="false"
      [contextMenuAllowed]="false"
      [showOpenFileButton]="false"
      [showHighlightEditor]="false"
    >
    </ngx-extended-pdf-viewer>
  </div>
</div>

<ng-template #signaturePadModal let-modal>
  <lib-signature-pad-dialog
    #signaturePadDialog
    [title]="'Sign Here'"
    [width]="'100%'"
    [height]="'400px'"
    [backgroundColor]="'rgb(255,255,255)'"
    [options]="{ penColor: 'black', minWidth: 0.5, maxWidth: 2.5 }"
    [showDownloadButton]="true"
    (signatureSaved)="savedSignature = $event; modal.dismiss($event)"
    (signatureCleared)="savedSignature = null"
  ></lib-signature-pad-dialog>
</ng-template>
